<template>
  <!-- Añadir justo antes del header -->
  <div class="shipping-banner">
    <div class="shipping-content">
      <div class="shipping-text">
        <span class="banner-item">
          <i class="fas fa-truck me-2"></i>
          Envíos a todo el país
        </span>
        <span class="banner-separator">•</span>
        <span class="banner-item">
          <i class="fas fa-medal me-2"></i>
          Garantía de germinación en todos los productos
        </span>
        <span class="banner-separator">•</span>
        <span class="banner-item">
          <i class="fas fa-lock me-2"></i>
          Compra 100% segura
        </span>
        <span class="banner-separator">•</span>
        <span class="banner-item">
          <i class="fas fa-truck me-2"></i>
          Envíos a todo el país
        </span>
        <span class="banner-separator">•</span>
        <span class="banner-item">
          <i class="fas fa-medal me-2"></i>
          Garantía de germinación en todos los productos
        </span>
      </div>
    </div>
  </div>
  <header class="fixed-top w-100" style="top: 40px;">
    <nav class="navbar navbar-expand-lg px-3" :class="{ 'navbar-scrolled': scrolled }">
      <div class="container">
        <a href="/">
          <img
            src='@/assets/images/logo.png'
            alt="Admin Panel"
            class="logo-img img-fluid"
          />
        </a>

        <!-- Desktop Menu -->
        <div class="d-none d-lg-flex align-items-center justify-content-between flex-grow-1">          <ul class="navbar-nav mx-auto">
            <li v-for="(item, index) in menuItems" :key="index" class="nav-item">
              <a 
                v-if="item.external"
                :href="item.route"
                class="nav-link fs-6"
                target="_blank"
              >
                <i :class="item.icon" class="me-2"></i>
                {{ item.label }}
              </a>
              <a 
                v-else
                :href="item.route"
                class="nav-link fs-6"
                @click.prevent="navigateTo(item)"
              >
                <i :class="item.icon" class="me-2"></i>
                {{ item.label }}
              </a>
            </li>
          </ul>

          <!-- Search Bar -->
          <div class="search-container me-4">
            <form @submit.prevent="handleSearch" class="search-form">
              <input
                type="text"
                v-model="searchQuery"
                class="search-input"
                placeholder="Buscar productos..."
                @focus="handleSearchFocus"
                @blur="handleSearchBlur"
                @input="handleSearchInput"
              >
              <button type="submit" class="search-button">
                <i class="fas fa-search"></i>
              </button>
            </form>

            <!-- Dropdown de resultados -->
            <div v-if="showResults && filteredProducts.length > 0" class="search-results">
              <router-link
                v-for="product in filteredProducts"
                :key="product.id"
                :to="`/producto/${product.id}`"
                class="search-result-item"
                @click="clearSearch"
              >
                <img :src="product.image" :alt="product.name" class="search-result-img">
                <div class="search-result-info">
                  <div class="search-result-name">{{ product.name }}</div>
                  <div class="search-result-brand">{{ product.brand }}</div>
                </div>
              </router-link>
              <div class="search-results-footer">
                <button @click="viewAllResults" class="view-all-btn">
                  Ver todos los resultados
                </button>
              </div>
            </div>
          </div>

          <!-- Auth & Cart Icons -->
          <div class="nav-actions">
            <router-link
              :to="isAuthenticated ? '/mi-cuenta' : '/login'"
              class="btn btn-primary account-btn"
            >
              <i class="fas fa-user"></i>
              <span class="ms-2 d-none d-sm-inline">{{ isAuthenticated ? username : "Mi cuenta" }}</span>
            </router-link>
            
            <router-link to="/carrito" class="cart-btn">
              <div class="cart-icon-wrapper">
                <i class="fas fa-shopping-cart"></i>
                <transition name="bounce">
                  <span v-if="cartItemsCount > 0" class="cart-counter">{{ cartItemsCount }}</span>
                </transition>
              </div>
            </router-link>
          </div>
        </div>

        <!-- Mobile Menu Button & Cart -->
        <div class="d-flex d-lg-none align-items-center gap-3">
          <button class="mobile-search-btn" @click="toggleMobileSearch">
            <i class="fas fa-search"></i>
          </button>
          <router-link to="/carrito" class="cart-btn">
            <div class="cart-icon-wrapper">
              <i class="fas fa-shopping-cart"></i>
              <transition name="bounce">
                <span v-if="cartItemsCount > 0" class="cart-counter">{{ cartItemsCount }}</span>
              </transition>
            </div>
          </router-link>

          <button
            class="menu-toggle"
            :class="{ 'is-active': isMenuOpen }"
            @click="toggleMenu"
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>

    <!-- Mobile Search Bar -->
    <div class="mobile-search" :class="{ 'mobile-search-active': showMobileSearch }">
      <form @submit.prevent="handleSearch" class="mobile-search-form">
        <input
          type="text"
          v-model="searchQuery"
          class="mobile-search-input"
          placeholder="Buscar productos..."
        >
        <button type="submit" class="mobile-search-button">
          <i class="fas fa-search"></i>
        </button>
        <button type="button" class="mobile-search-close" @click="toggleMobileSearch">
          <i class="fas fa-times"></i>
        </button>
      </form>
    </div>

    <!-- Mobile Menu -->
    <transition name="slide-down">
      <div v-if="isMenuOpen" class="mobile-menu" @click.self="closeMenu">
        <div class="mobile-menu-container">          <ul class="mobile-nav">
            <li v-for="(item, index) in menuItems" :key="index">
              <a 
                v-if="item.external"
                :href="item.route"
                class="mobile-nav-link text-decoration-none"
                target="_blank"
                @click="closeMenu"
              >
                <i :class="item.icon" class="me-3"></i>
                {{ item.label }}
              </a>
              <a 
                v-else
                :href="item.route"
                class="mobile-nav-link text-decoration-none"
                @click.prevent="() => { navigateTo(item); closeMenu(); }"
              >
                <i :class="item.icon" class="me-3"></i>
                {{ item.label }}
              </a>
            </li>
            <li class="mobile-nav-account">
              <router-link to="/mi-cuenta" class="btn btn-primary w-100" @click="closeMenu">
                <i class="fas fa-user me-2"></i>
                {{ isAuthenticated ? username : "Mi cuenta" }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';

const store = useStore();
const scrolled = ref(false);
const isMenuOpen = ref(false);

// Obtener el nombre de usuario desde localStorage
const storedUsername = localStorage.getItem("username");
// Procesar el nombre de usuario para mostrar solo la parte anterior al @ si es un email
const username = computed(() => {
  if (storedUsername && storedUsername.includes('@')) {
    return storedUsername.split('@')[0];
  }
  return storedUsername;
});

// Función reactiva para obtener productos disponibles
const products = computed(() => {
  const allProducts = JSON.parse(localStorage.getItem("products")) || [];
  // Filtrar solo productos disponibles para el navbar (usuarios públicos)
  return allProducts.filter(product => product.available !== false);
});

const menuItems = [
  { label: 'Artículos', route: 'https://jamrockgrowshop.com.ar', icon: 'fas fa-bong', external: true },
  { label: 'Automáticas', route: '/productos?categories=automaticas', icon: 'fas fa-seedling' },
  { label: 'Feminizadas', route: '/productos?categories=feminizadas', icon: 'fas fa-venus' },
  { label: 'Regulares', route: '/productos?categories=regulares', icon: 'fas fa-leaf' },
  { label: 'Ofertas', route: '/productos?category=ofertas', icon: 'fas fa-tags' }
];

// Computed property para verificar autenticación
const isAuthenticated = computed(() => {
  return localStorage.getItem("accessToken") !== null;
});

// Computed property for cart count from Vuex store
const cartItemsCount = computed(() => store.getters.cartCount);

const router = useRouter();
const searchQuery = ref('');
const showMobileSearch = ref(false);

// Esta función maneja la navegación de los elementos del menú
const navigateTo = (item) => {
  // Extraer la ruta base y la query string
  const [path, queryString] = item.route.split('?');
  
  // Convertir la query string en un objeto
  const params = {};
  if (queryString) {
    const searchParams = new URLSearchParams(queryString);
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
  }

  // Usar una solución más directa para recargar la página con los nuevos parámetros
  // Primero construir la nueva URL completa
  const baseUrl = window.location.origin + path;
  const queryPart = new URLSearchParams(params).toString();
  const fullUrl = baseUrl + (queryPart ? '?' + queryPart : '');
  
  // Recargar la página con la nueva URL
  window.location.href = fullUrl;
};

const handleSearch = () => {
  if (searchQuery.value.trim()) {
    // Construir los parámetros de consulta
    const params = {
      search: searchQuery.value.trim()
    };
    
    // Mantener otros filtros activos
    if (router.currentRoute.value.query.categories) {
      params.categories = router.currentRoute.value.query.categories;
    }
    if (router.currentRoute.value.query.banks) {
      params.banks = router.currentRoute.value.query.banks;
    }
    
    // Construir la URL completa
    const baseUrl = window.location.origin + '/productos';
    const queryPart = new URLSearchParams(params).toString();
    const fullUrl = baseUrl + (queryPart ? '?' + queryPart : '');
    
    // Recargar la página con la nueva URL
    window.location.href = fullUrl;
    
    searchQuery.value = '';
    showMobileSearch.value = false;
  }
};

const toggleMobileSearch = () => {
  showMobileSearch.value = !showMobileSearch.value;
};

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  scrolled.value = isMenuOpen.value;
};

const closeMenu = () => {
  isMenuOpen.value = false;
};

const handleScroll = () => {
  scrolled.value = window.scrollY > 50;
};


onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  console.log(products);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

// Estado para búsqueda
const showResults = ref(false);
const filteredProducts = ref([]);

// Manejar focus del input
const handleSearchFocus = () => {
  scrolled.value = true;
  showResults.value = true;
  handleSearchInput();
};

// Manejar blur del input
const handleSearchBlur = () => {
  setTimeout(() => {
    showResults.value = false;
    if (!isMenuOpen.value && window.scrollY <= 50) {
      scrolled.value = false;
    }
  }, 200);
};

// Filtrar productos
const handleSearchInput = () => {
  if (searchQuery.value.length >= 2) {
    filteredProducts.value = products.value
      .filter(product => {
        const query = searchQuery.value.toLowerCase();
        return (
          product.name.toLowerCase().includes(query) ||
          product.brand.toLowerCase().includes(query)
        );
      })
      .slice(0, 5); // Limitar a 5 resultados
  } else {
    filteredProducts.value = [];
  }
};

// Limpiar búsqueda
const clearSearch = () => {
  searchQuery.value = '';
  showResults.value = false;
};

// Ver todos los resultados
const viewAllResults = () => {
  // Construir los parámetros de consulta
  const params = {
    search: searchQuery.value
  };
  
  // Mantener otros filtros activos
  if (router.currentRoute.value.query.categories) {
    params.categories = router.currentRoute.value.query.categories;
  }
  if (router.currentRoute.value.query.banks) {
    params.banks = router.currentRoute.value.query.banks;
  }
  
  // Construir la URL completa
  const baseUrl = window.location.origin + '/productos';
  const queryPart = new URLSearchParams(params).toString();
  const fullUrl = baseUrl + (queryPart ? '?' + queryPart : '');
  
  // Recargar la página con la nueva URL
  window.location.href = fullUrl;
  
  clearSearch();
};
</script>

<style scoped>
/* Base Styles */
.navbar {
  padding: 0.75rem 0;
  transition: all 0.3s ease;
  background: transparent;
}

.navbar-scrolled {
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.navbar-brand {
  width: 200px;
}

.logo-img {
  height: 70px !important;
}

/* Navigation Links */
.nav-link {
  position: relative;
  padding: 0.5rem 1rem;
  color: var(--white-color);
  font-weight: 500;
  transition: all 0.3s ease;
  margin: 0 0.5rem;
  cursor: pointer;
}

.nav-link:hover {
  color: var(--primary-color);
  transform: translateY(-2px);
}

.nav-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--primary-color);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: right;
}

.nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

/* Action Buttons */
.nav-actions {
  display: flex;
  align-items: center;
}

.account-btn {
  padding: 0.5rem 1rem;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.account-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.cart-btn {
  position: relative;
  padding: 0.5rem;
  color: var(--white-color);
  transition: all 0.3s ease;
}

.cart-btn:hover {
  color: var(--primary-color);
}

.cart-icon-wrapper {
  position: relative;
  font-size: 1.25rem;
}

.cart-counter {
  position: absolute;
  top: -8px;
  right: -8px;
  background: var(--primary-color);
  color: white;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Mobile Menu Button */
.menu-toggle {
  width: 30px;
  height: 24px;
  position: relative;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--white-color);
  position: absolute;
  left: 0;
  transition: all 0.3s ease;
}

.menu-toggle span:nth-child(1) { top: 0; }
.menu-toggle span:nth-child(2) { top: 50%; transform: translateY(-50%); }
.menu-toggle span:nth-child(3) { bottom: 0; }

.menu-toggle.is-active span:nth-child(1) { transform: rotate(45deg) translate(10px, 2px); }
.menu-toggle.is-active span:nth-child(2) { opacity: 0; }
.menu-toggle.is-active span:nth-child(3) { transform: rotate(-45deg) translate(15px, -5px); }

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 140px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000;
}

.mobile-menu-container {
  padding: 2rem;
  background: var(--black-color);
}

.mobile-nav {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  padding: 1rem;
  color: var(--white-color);
  font-size: 1.1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.mobile-nav-link:hover {
  background: rgba(255, 255, 255, 0.05);
  padding-left: 1.5rem;
}

.mobile-nav-account {
  margin-top: 2rem;
  padding: 0 1rem;
}

/* Animations */
.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* Responsive Adjustments */
@media (max-width: 991.98px) {
  .navbar {
    padding: 0.5rem 0;
  }
  
  .logo-img {
    height: 35px;
  }
  
  .cart-counter {
    min-width: 18px;
    height: 18px;
    font-size: 0.7rem;
  }
}

/* Search Styles */
.search-container {
  position: relative;
  width: 300px;
}

.search-form {
  display: flex;
  align-items: center;
}

.search-input {
  width: 100%;
  padding: 0.5rem 1rem;
  padding-right: 2.5rem;
  border: none;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--white-color);
  transition: all 0.3s ease;
}

.search-input:focus {
  background: rgba(255, 255, 255, 0.15);
  outline: none;
  box-shadow: 0 0 0 2px var(--primary-color);
}

.search-button {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--white-color);
  padding: 0.5rem;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.search-button:hover {
  opacity: 1;
}

/* Mobile Search Styles */
.mobile-search {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  background: var(--black-color-3);
  padding: 1rem;
  transition: top 0.3s ease;
  z-index: 1000;
}

.mobile-search-active {
  top: 40px;
}

.mobile-search-form {
  display: flex;
  gap: 0.5rem;
}

.mobile-search-input {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--white-color);
}
.mobile-search-button,
.mobile-search-close {
  background: none;
  border: none;
  color: var(--white-color);
  padding: 0.5rem;
  font-size: 1.2rem;
}

.mobile-search-btn {
  background: none;
  border: none;
  color: var(--white-color);
  font-size: 1.2rem;
  padding: 0.5rem;
}

.shipping-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: var(--primary-color);
  overflow: hidden;
  z-index: 1100;
}

.shipping-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.shipping-text {
  color: white;
  font-weight: 500;
  white-space: nowrap;
  animation: scrollText 20s linear infinite; /* Reducido a 20s para mayor velocidad */
  padding: 0 2rem;
  display: flex;
  align-items: center;
  gap: 1rem; /* Añadido gap entre elementos */
}

.banner-item {
  padding: 0 2rem; /* Aumentado el padding */
  display: flex;
  align-items: center;
  font-size: 0.9rem; /* Tamaño de fuente ligeramente reducido */
}

.banner-separator {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 2rem; /* Aumentado el margen */
  font-size: 1.2rem; /* Punto separador más grande */
}

@keyframes scrollText {
  0% {
    transform: translateX(50%); /* Cambiado a 50% para que aparezca antes */
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Ajustar altura de navbar en móviles */
@media (max-width: 991.98px) {
  .mobile-menu {
    top: 140px;
  }
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: var(--black-color-3);
  border-radius: 8px;
  margin-top: 0.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.search-result-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s ease;
}

.search-result-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.search-result-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-right: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.search-result-info {
  flex: 1;
}

.search-result-name {
  color: var(--white-color);
  font-size: 0.9rem;
  font-weight: 500;
}

.search-result-brand {
  color: var(--white-color-2);
  font-size: 0.8rem;
  opacity: 0.7;
}

.search-results-footer {
  padding: 0.75rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.view-all-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  text-decoration: underline;
}
</style>
